var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "aftersale-table" },
    [
      _c(
        "el-table",
        {
          ref: "aftersaleTable",
          staticStyle: { width: "100%" },
          attrs: { data: _vm.data, border: "", "max-height": "300" },
          on: { "selection-change": _vm.selectAftersale }
        },
        [
          _c("el-table-column", {
            attrs: { type: "selection", width: "55", fixed: "left" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "40" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "created_at", label: "日期", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            return _vm.getDetailTable(scope.row)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.created_at) +
                            "\n        "
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "as_number", label: "服务编号", width: "130" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "span",
                      {
                        class: [
                          "blue",
                          scope.row.aftersale_expire_timeout ? "red" : ""
                        ],
                        on: {
                          click: function($event) {
                            return _vm.getDetailTable(scope.row)
                          }
                        }
                      },
                      [_vm._v(_vm._s(scope.row.as_number))]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "order_number", label: "订单号", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            return _vm.getDetailTable(scope.row)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.order_number) +
                            "\n        "
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "user_name", label: "客户姓名" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            return _vm.getDetailTable(scope.row)
                          }
                        }
                      },
                      [
                        _c("MaskViewVue", {
                          attrs: {
                            type: "maskName",
                            maskVal: scope.row.user_name,
                            customParams: {
                              expand: JSON.stringify({
                                xAPIVersion: "V1.0",
                                xSystemID: "diablo"
                              })
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "applied_num", label: "申请数量", width: "65" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            return _vm.getDetailTable(scope.row)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.applied_num) +
                            "\n        "
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "applied_price", label: "申请金额" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            return _vm.getDetailTable(scope.row)
                          }
                        }
                      },
                      [
                        scope.row.as_typeName === "维修"
                          ? _c("div", [_vm._v("-")])
                          : _c("div", [_vm._v(_vm._s(scope.row.applied_price))])
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "received_num", label: "收货数量", width: "65" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            return _vm.getDetailTable(scope.row)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.received_num) +
                            "\n        "
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "accepted_num", label: "确认数量", width: "65" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            return _vm.getDetailTable(scope.row)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.accepted_num) +
                            "\n        "
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "accepted_price", label: "确认金额" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            return _vm.getDetailTable(scope.row)
                          }
                        }
                      },
                      [
                        scope.row.as_typeName === "维修"
                          ? _c("div", [_vm._v("-")])
                          : _c("div", [
                              _vm._v(_vm._s(scope.row.accepted_price))
                            ])
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "returned_num", label: "出库数量", width: "65" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            return _vm.getDetailTable(scope.row)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.returned_num) +
                            "\n        "
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "as_statusName", label: "售后状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        class: { close: scope.row.as_statusName === "关闭" },
                        on: {
                          click: function($event) {
                            return _vm.seeColseReasonHandler(scope.row)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.as_statusName) +
                            "\n          "
                        ),
                        scope.row.as_statusName === "关闭"
                          ? _c("span", {
                              staticClass: "el-icon-warning",
                              style: { color: "#236bdc" }
                            })
                          : _vm._e()
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _vm.isZhifaOrFactory
            ? _c("el-table-column", {
                attrs: { prop: "in_box_status_msg", label: "提货物流状态" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.getDetailTable(scope.row)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(scope.row.in_box_status_msg) +
                                  "\n        "
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1880067459
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isZhifaOrFactory
            ? _c("el-table-column", {
                attrs: { prop: "out_box_status_msg", label: "送货物流状态" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.getDetailTable(scope.row)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(scope.row.out_box_status_msg) +
                                  "\n        "
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2617079786
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "as_typeName", label: "售后类型" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            return _vm.getDetailTable(scope.row)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.as_typeName) +
                            "\n        "
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "as_status_source",
              label: "处理方式",
              width: "100"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.as_status_source == "1"
                      ? _c("span", [_vm._v("店铺处理")])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.as_status_source == "2"
                      ? _c("span", [_vm._v("客服处理")])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "confirm_source",
              label: "最终处理人",
              width: "100"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.confirm_source == 1
                      ? _c("span", [_vm._v("店铺处理")])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.confirm_source == 2
                      ? _c("span", [_vm._v("客服处理")])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.confirm_source == 3
                      ? _c("span", [_vm._v("系统处理")])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _vm.isFactory
            ? _c("el-table-column", {
                attrs: { prop: "user_mobile", label: "客户电话", width: "100" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.getDetailTable(scope.row)
                                }
                              }
                            },
                            [
                              _c("MaskViewVue", {
                                attrs: {
                                  type: "maskPhone",
                                  maskVal: scope.row.user_mobile,
                                  customParams: {
                                    expand: JSON.stringify({
                                      xAPIVersion: "V1.0",
                                      xSystemID: "diablo"
                                    })
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1818383803
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isFactory
            ? _c("el-table-column", {
                attrs: {
                  prop: "user_address",
                  label: "客户地址",
                  width: "300"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.getDetailTable(scope.row)
                                }
                              }
                            },
                            [
                              _c("MaskViewVue", {
                                attrs: {
                                  type: "maskAddress",
                                  maskVal: scope.row.user_address,
                                  customParams: {
                                    expand: JSON.stringify({
                                      xAPIVersion: "V1.0",
                                      xSystemID: "diablo"
                                    })
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1610587975
                )
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isZhifaOrFactory
            ? _c("el-table-column", {
                attrs: { prop: "abnormal", label: "异常", width: "60" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("i", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: scope.row.is_abnormal === "1",
                                expression: "scope.row.is_abnormal === '1'"
                              }
                            ],
                            staticClass: "el-icon-warning"
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2744424763
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", fixed: "right", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        style: { color: "#236bdc" },
                        attrs: { size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.getBoxData(scope.row)
                          }
                        }
                      },
                      [_vm._v("查看")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        style: { color: "#236bdc" },
                        attrs: { size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.changeBoxData(scope.row)
                          }
                        }
                      },
                      [_vm._v("新建工单")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.closeReasonDialog,
            title: "关闭原因",
            "append-to-body": true,
            width: "400px"
          },
          on: {
            "update:visible": function($event) {
              _vm.closeReasonDialog = $event
            }
          }
        },
        [
          _c(
            "span",
            {
              style: { color: "#fff" },
              attrs: { slot: "title" },
              slot: "title"
            },
            [_vm._v("服务编号：" + _vm._s(_vm.close_as_number))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "close-reason" }, [
            _c("table", { attrs: { border: "1", cellspacing: "0" } }, [
              _c("tr", [
                _c("th", [_vm._v("关闭原因")]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n            " + _vm._s(_vm.closeReason) + "\n          "
                  )
                ])
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d518bd8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d518bd8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aftersale/aftersale-table.vue
// module id = null
// module chunks = 